import { Pagination as PaginationBase, type PaginationProps as PaginationBaseProps } from '@mantine/core'
import { IconChevronLeft, IconChevronRight, IconChevronsLeft, IconChevronsRight, IconDots } from '@tabler/icons-react'
import { type FC, useCallback } from 'react'

export interface PaginationProps extends Omit<PaginationBaseProps, 'total'> {
  total?: number
}

export const Pagination: FC<PaginationProps> = ({ total = 0, ...props }) => (
  <PaginationBase
    align='center'
    color='bay'
    disabled={total < 2}
    dotsIcon={IconDots}
    firstIcon={IconChevronsLeft}
    getControlProps={useCallback(
      (control: string) => ({
        'aria-label': control
      }),
      []
    )}
    lastIcon={IconChevronsRight}
    nextIcon={IconChevronRight}
    noWrap
    position='center'
    previousIcon={IconChevronLeft}
    radius='xl'
    total={total}
    withEdges
    {...props}
  />
)
